import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
p.blue {
  color: blue;
}`],
})
export class PageMainComponent implements OnInit {
    public event: any = {};
    public opts: any = {};
    public data: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();

        this.event.view = this.view.bind(this);
        this.event.lang = this.lang.bind(this);
        this.event.set = this.set.bind(this);
        this.event.get = this.get.bind(this);

        await this.view("main");
        await this.service.render();
    }

    public async view(view: string) {
        this.opts.view = view;
        await this.service.render();
    }

    public async lang(lang: string) {
        this.opts.lang = lang;
        await this.service.render();
    }

    public async set(key: any, value: any) {
        this.data[key] = value;
        await this.service.render();
    }

    public get(key: any) {
        return this.data[key];
    }

}

export default PageMainComponent;